import { c as _c } from "react/compiler-runtime";
import type { VaultKind } from '@onefootprint/request-types';
import { useRouter } from 'next/router';
type EntityKind = {
  kind: VaultKind;
  urlPath: string;
};
const useEntityKind = () => {
  const $ = _c(2);
  const router = useRouter();
  if (router.pathname.includes("users")) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = {
        kind: "person",
        urlPath: "users"
      };
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  } else {
    if (router.pathname.includes("businesses")) {
      let t0;
      if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
          kind: "business",
          urlPath: "businesses"
        };
        $[1] = t0;
      } else {
        t0 = $[1];
      }
      return t0;
    }
  }
};
export default useEntityKind;